import { Modal } from 'bootstrap'
export default class MessageModal {
    constructor() {
        console.log('%c👍🏼 Message Modal', 'color: yellow');
    }
    init() {
        let messageModalShown = sessionStorage.getItem('messageModalShown');

        if(messageModalShown != 'true'){
            let messageModalEl = document.querySelector('#messageModal');
            let messageModal = Modal.getOrCreateInstance(messageModalEl); // Returns a Bootstrap modal instance
            messageModal.show();
            sessionStorage.setItem('messageModalShown', 'true');
        }
    }
}